import "./css/Mobile.css";
import "./css/globals.css";
import "./css/fonts.css";
import React, { createContext, useState, useMemo, useRef } from "react";
import ReactDOM from "react-dom/client";
// import Unlimited from "./components/archive/Unlimited";
// import Daily from "./components/archive/Daily";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Helmet } from "react-helmet";
import ContactPage from "./pages/ContactPage";
import AboutPage from "./pages/AboutPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";

export const AppContext = createContext();

// Renamed functional component to RootComponent to avoid conflict with the root variable
const RootComponent = () => {
    const [gameMode, setGameMode] = useState("Team");
    const headerRef = useRef(null);
    const footerRef = useRef(null);
    // const [showTutorial, setShowTutorial] = useState(false);
    const setShowTutorial = () => {}; // tutorial popover deprecated for static tutorial ui

    const contextValue = useMemo(() => {
        const gameModeOptions = ["Team", "Player"];
        return {
            gameModeOptions,
            gameMode,
            setGameMode,
            setShowTutorial,
            headerRef,
            footerRef,
        };
    }, [gameMode, setGameMode]);

    // useEffect(() => {
    //     window.ezstandalone = window.ezstandalone || {};
    //     window.ezstandalone.cmd = window.ezstandalone.cmd || [];
    //     window.ezstandalone.cmd.push(function () {
    //         window.ezstandalone.define(101, 102, 103, 104);
    //         window.ezstandalone.enable();
    //         window.ezstandalone.display();
    //         console.log("EZ Standalone initialized successfully!");
    //     });
    // }, []);

    return (
        <React.StrictMode>
            <Helmet>
                {/* <script async src="//www.ezojs.com/ezoic/sa.min.js"></script> */}
                <script
                    async
                    src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-8255221704339624"
                    crossorigin="anonymous"
                ></script>
                <meta
                    name="google-adsense-account"
                    content="ca-pub-8255221704339624"
                />
            </Helmet>
            <BrowserRouter>
                <AppContext.Provider value={contextValue}>
                    <Header
                        headerRef={headerRef}
                        setShowTutorial={setShowTutorial}
                    />
                    <Routes>
                        <Route
                            path="/contact"
                            element={<ContactPage key="Contact" />}
                        />
                        <Route
                            path="/about"
                            element={<AboutPage key="About" />}
                        />
                        <Route
                            path="/privacy-policy"
                            element={<PrivacyPolicyPage key="PrivacyPolicy" />}
                        />
                        <Route
                            path="*"
                            element={<Home key="Daily" gameType="Daily" />}
                        />
                        <Route
                            path="/unlimited"
                            element={
                                <Home key="Unlimited" gameType="Unlimited" />
                            }
                        />
                    </Routes>
                    <Footer footerRef={footerRef} />
                </AppContext.Provider>
            </BrowserRouter>
        </React.StrictMode>
    );
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<RootComponent />);
